import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'checkout-card-offer-header',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './card-offer-header.component.html',
    styleUrl: 'card-offer-header.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardOfferHeaderComponent {
    @Input() public dataEnvelope: string;
    @Input() public catchyDescription: string;
    @Input() public gencode: string;
    @Input() public isLocked: boolean;
    @Input() public canBeLockedPlan: boolean;
    @Input() public connectionSpeed: '4g' | '5g';
    @Input() public atLeastOneBlockablePlan: boolean = false;

    @Output() public lockedToggleEvent = new EventEmitter<boolean>();

    public lockedToggle(): void {
        this.isLocked = !this.isLocked;
        this.lockedToggleEvent.emit(this.isLocked);
    }
}
